import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent, HttpXsrfTokenExtractor } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";

import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { Constants } from '../common/constants';
import { ErrorData } from '../common/ErrorData';
import { SharedService } from '../common/shared.service';
import { Utils } from '../common/utils.component';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

  isRefreshingToken = 0;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  authService: APIService;

  constructor(private injector: Injector, private sharedSer: SharedService, private xsrfTokenExtractor: HttpXsrfTokenExtractor) { }

  addToken(req: HttpRequest<any>): HttpRequest<any> {
    let xsrfToken = this.xsrfTokenExtractor.getToken();
    var needencrypt: boolean = true;
    if (!req.url.includes('api/oauth/refresh') && req.url.includes('api/oauth/'))
      needencrypt = false;

    if (xsrfToken != null) {
      // create a copy of the request and
      // append the XSRF token to the headers list
      if (!needencrypt)
        return req.clone({ withCredentials: true, setHeaders: { Authorization: 'Bearer ' + GlobalConstants.Jwi, InternalApp: GlobalConstants.Tid, 'X-XSRF-TOKEN': xsrfToken, TUN: new Utils().getEncryptedHeaderString(GlobalConstants.Name) } })
      else
        return req.clone({ withCredentials: true, setHeaders: { Authorization: 'Bearer ' + GlobalConstants.Jwi, InternalApp: new Utils().getEncryptedHeaderString(GlobalConstants.Tid), 'X-XSRF-TOKEN': xsrfToken, TUN: new Utils().getEncryptedHeaderString(GlobalConstants.Name) } })
    }
    else {
      if (!needencrypt)
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + GlobalConstants.Jwi, InternalApp: GlobalConstants.Tid, TUN: new Utils().getEncryptedHeaderString(GlobalConstants.Name) } })
      else
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + GlobalConstants.Jwi, InternalApp: new Utils().getEncryptedHeaderString(GlobalConstants.Tid), TUN: new Utils().getEncryptedHeaderString(GlobalConstants.Name) } })
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    this.authService = this.injector.get(APIService);
    if (!window.navigator.onLine) {
      return throwError(this.noInternetError())
    }
    if (localStorage.getItem(Constants.IS429) == "1") {
      if (new Date().getTime() < Number(localStorage.getItem(Constants.TIMEOUT429))) {
        localStorage.setItem(Constants.IS429, "1")
        return throwError(this.get429ErrorData());
      } else {
        localStorage.setItem(Constants.IS429, "0")
        localStorage.setItem(Constants.TIMEOUT429, "0")
      }
    }

    return next.handle(this.addToken(req)).pipe(
      catchError(error => {

        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 401:
              return this.handle401Error(req, next);
            case 429:
              return this.handle429Error(error, req.url)
            default: {
              return this.handleError(error, req.url);
            }
          }
        } else {
          return this.handleError(error, req.url);
        }
      }));
  }
  noInternetError() {
    var errorData = new ErrorData()
    errorData.errorCode = 1
    errorData.errorMsg = Constants.NO_INTERNET_MSG
    return errorData
  }
  get429ErrorData() {
    var errorData = new ErrorData()
    errorData.errorCode = Constants.CONNECTION_LIMIT_EXCEED
    errorData.errorMsg = Constants.CONNECTION_LIMIT_EXCEED_MSG
    return errorData
  }

  handle429Error(error, url) {
    var xRateTime: string = error.error.headers['X-RateLimit-Reset']
    if (xRateTime.length > 0 && Number(xRateTime) > 1) {
      var time = Number(xRateTime) * 1000;
      localStorage.setItem(Constants.IS429, "1")
      localStorage.setItem(Constants.TIMEOUT429, time + "")
    }
    return this.handleError(error, url)
  }

  public handleError(error: HttpErrorResponse, url: string) {
    var errorData = new ErrorData()
    errorData.errorCode = error.status
    if (errorData.errorCode == 429) {
      errorData.errorMsg = Constants.CONNECTION_LIMIT_EXCEED_MSG
    } else if (errorData.errorCode == 404) {
      errorData.errorMsg = Constants.ERROR_MSG_404
    } else {
      if (errorData.errorCode == 403) {
        if (url.includes(Constants.APPBASE_URL_403)) {
          errorData.errorMsg = Constants.APPBASE_URL_MSG
        } else {
          errorData.errorMsg = Constants.ERROR_MSG_403
        }
      }
      if (error.error != null && error.error != undefined && error.error.errorDetails != undefined) {

        errorData.errorJson = error.error.errorDetails

        errorData.errorMsg = JSON.parse(errorData.errorJson)['summary'];
        var refCode = JSON.parse(errorData.errorJson)['ref']
        if (refCode != undefined && refCode.length > 0 && !isNaN(parseFloat(refCode)) && !isNaN(refCode - 0))
          errorData.refCode = Number(refCode)

        switch (errorData.refCode) {
          case Constants.SHARE_LINK_RESTRICTED:
            errorData.errorMsg = Constants.SHARE_LINK_RESTRICTED_MSG
            break;
          case Constants.IP_RES:
            errorData.errorMsg = Constants.IP_RES_ERR_MSG
            break;
          case Constants.VIRUS_DETECTED:
            errorData.errorMsg = Constants.VIRUS_DETECTED_MSG
            break;
          case Constants.BLACK_OR_WHITE_LISTED:
            errorData.errorMsg = Constants.BLACK_OR_WHITE_LISTED_MSG
            break;
          case Constants.QUOTA_EXCEEDED:
            errorData.errorMsg = Constants.QUOTA_EXCEEDED_MSG
            break;
          case Constants.FILE_SHARING_DISABLED:
            errorData.errorMsg = Constants.FILE_SHARING_DISABLED_MSG
            break;
          case Constants.EXTERNAL_USER_SHARE_ACCESS_DENIED_WHEN_SHARING_ON:
            errorData.errorMsg = Constants.EXTERNAL_USER_SHARE_ACCESS_DENIED_WHEN_SHARING_ON_MSG
            break;
          case Constants.ENABLE_API_IS_FALSE:
            errorData.errorMsg = Constants.ENABLE_API_IS_FALSE_MSG
            break;
          case Constants.API_ALLOWED_IP_RESTRICTION:
            errorData.errorMsg = Constants.API_ALLOWED_IP_RESTRICTION_MSG
            break;
          case Constants.SQL_CONNECTION_LIMIT_EXCEEDED:
            errorData.errorMsg = Constants.COMMON_ERR_MSG
            break;
          case Constants.CONNECTION_LIMIT_EXCEED:
            errorData.errorMsg = Constants.CONNECTION_LIMIT_EXCEED_MSG
            break;
          case Constants.CHUNK_MISSING_FILE_DETAILS:
          case Constants.CHUNK_NOT_ALLOWED:
          case Constants.CHUNK_SIZE_MISMATCH:
          case Constants.CHUNK_RENAME_ERROR:
            errorData.errorMsg = Constants.ERROR_CHUNK_NOT_ALLOWED
          break;  
          default:
            if (errorData.errorCode == 403) {
              errorData.errorMsg = Constants.ERROR_MSG_403
            }
            break;
        }
      }
    }
    if (errorData.errorMsg.length == 0) {
      errorData.errorMsg = Constants.COMMON_ERR_MSG
    }
    return throwError(errorData);
  }

  handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes("unauthorizeuser")) {
      this.sharedSer.logout();
      this.logoutUser()
    } else if (this.isRefreshingToken < 3) {
      this.isRefreshingToken += 1;
      return this.authService.refresh().pipe(
        switchMap((newToken: string) => {
          if (GlobalConstants.Jwi) {
            this.isRefreshingToken = 0;
            this.tokenSubject.next(newToken);
            return next.handle(this.addToken(req)).pipe(
              catchError(error => {
                if (error.status == 429) {
                  return this.handle429Error(error, req.url)
                } else {
                  return this.handleError(error, req.url);
                }
              }));
          }

          // If we don't get a new token, we are in trouble so logout.
          return this.logoutUser();
        }),
        finalize(() => {
        }));
    } else {
      if (req.url.includes("unauthorizeuser")) {
        this.sharedSer.logout();
        this.logoutUser()

      } else {
        this.authService.logoutUser()
          .subscribe(share => {
            this.sharedSer.logout()
            this.logoutUser()
          });
        this.logoutUser()
      }
    }
  }

  logoutUser() {
    // Route to the login page (implementation up to you)
    this.sharedSer.logout();
    var errorData = new ErrorData()
    errorData.errorCode = Constants.LOGGED_OUT
    errorData.errorMsg = Constants.LOGGED_OUT_MSG
    return throwError(errorData)
  }
}
